<template>
  <div>
    <hr />

    <DataTable
      :data="medioperss"
      :columns="[
        { label: 'Medio',       field: 'medioComNombre' },
        { label: 'Descripción', field: 'descripcion' },
        { label: 'Fecha Reg.',  field: 'fechaReg',
          format: (v) => getFormattedDate(v, 'DD/MM/YYYY') },
      ]"
      idField="idMedioPers"
      mensajeVacio="No hay medios de comunicación registrados."
      :acciones="true"
      :mostrarInfo="false"	  
      :mostrarEditar="false"
      :mostrarVer="false"
      :mostrarEliminar="false"
      :mostrarBotonNuevo="false"
      @refresh="getData"
    >
      <!-- Botón Nuevo en barra de acciones -->
      <template #acciones-extra>
        <div class="col-auto">
          <button
            class="btn btn-outline-success btn-sm d-flex align-items-center gap-1"
            data-bs-toggle="modal"
            data-bs-target="#ventanaModal"
            @click="abrirModalCrear"
            title="Nuevo registro"
          >
            <span class="material-icons" style="font-size:16px">add_box</span> Nuevo
          </button>
        </div>
      </template>

      <!-- Acciones por fila -->
      <template #acciones-fila="{ row }">
        <button
          class="btn btn-sm btn-outline-warning me-1"
          @click="abrirModalEditar(row.idMedioPers)"
          title="Editar"
        >
          <span class="material-icons" style="font-size:14px">edit</span>
        </button>
        <button
          class="btn btn-sm btn-outline-danger"
          @click="deleteMedioPers(row.idMedioPers)"
          title="Eliminar"
        >
          <span class="material-icons" style="font-size:14px">delete</span>
        </button>
      </template>
    </DataTable>

    <!-- Modal -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-labelledby="ventanaModalLabel"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <span class="material-icons" style="font-size:24px; color:white">contact_phone</span>
            <h5 class="modal-title text-white ms-2" id="ventanaModalLabel">{{ titulo }}</h5>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
          </div>
          <form>
            <div class="modal-body">
              <div class="row g-3">

                <!-- Id (solo editar) -->
                <div class="col-md-2" v-if="btnEditar">
                  <label class="form-label fw-bold">Id</label>
                </div>
                <div class="col-md-10" v-if="btnEditar">
                  <input type="text" class="form-control bg-light" v-model="datoMedioPers.idMedioPers" disabled />
                </div>

                <!-- Medio de Comunicación -->
                <div class="col-md-2">
                  <label class="form-label fw-bold">Medio</label>
                </div>
                <div class="col-md-10">
                  <select class="form-select" v-model="datoMedioPers.idMedioCom">
                    <option
                      v-for="m in medioComs"
                      :key="m.idMedioCom"
                      :value="m.idMedioCom"
                    >{{ m.nombre }}</option>
                  </select>
                </div>

                <!-- Descripción -->
                <div class="col-md-2">
                  <label class="form-label fw-bold">Descripción</label>
                </div>
                <div class="col-md-10">
                  <input
                    type="text"
                    class="form-control"
                    v-model="datoMedioPers.descripcion"
                    required
                  />
                </div>

                <!-- Fecha Reg (solo editar) -->
                <div class="col-md-2" v-if="btnEditar">
                  <label class="form-label fw-bold">Fecha Reg.</label>
                </div>
                <div class="col-md-10" v-if="btnEditar">
                  <input
                    type="text"
                    class="form-control bg-light"
                    :value="getFormattedDate(datoMedioPers.fechaReg)"
                    disabled
                  />
                </div>

              </div>
            </div>
          </form>
          <div class="modal-footer">
            <button
              v-if="btnCrear"
              type="button"
              class="btn btn-success px-4"
              @click.prevent="guardarMedioPers"
              title="Guardar"
            >
              <span class="material-symbols-outlined align-middle">save</span> Guardar
            </button>
            <button
              v-if="btnEditar"
              type="button"
              class="btn btn-success px-4"
              @click.prevent="guardarEditMedioPers"
              title="Actualizar"
            >
              <span class="material-symbols-outlined align-middle">update</span> Actualizar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from '@/components/DataTable.vue';
import { validarForm } from '@/modules/validacionesForms.js';
import dateFormat from '@/modules/dateFormat.js';
import api from '@/services/api';
import * as $ from 'jquery';
import swal from 'sweetalert';
window['$'] = $;
window['jQuery'] = $;

export default {
  components: { DataTable },

  props: {
    p_idPersona: { type: String, required: true },
  },

  data() {
    return {
      medioperss:    [],
      datoMedioPers: {},
      titulo:        '',
      btnCrear:      false,
      btnEditar:     false,
      modalWindow:   true,
      medioComs:     [],
    };
  },

  watch: {
    p_idPersona(newVal, oldVal) {
      if (newVal !== oldVal) this.getData();
    },
  },

  mounted() {
    this.getData();
    this.fetchMedioComs();
  },

  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },

    //  Carga
    async getData() {
      const response = await api.get('/vwmedioperss/idpersona/' + this.p_idPersona);
      this.medioperss = response.data.reverse();
    },

    //  Validación
    validarForm() {
      return validarForm(
        this.datoMedioPers,
        ['idMedioCom', 'descripcion'],
        ['Medio de Comunicación', 'Descripción']
      );
    },

    //  CRUD
    async guardarMedioPers() {
      if (this.validarForm() === 1) {
        try {
          this.datoMedioPers.idPersona = this.p_idPersona;
          await api.post('/medioperss', this.datoMedioPers);
          $('#ventanaModal').modal('hide');
          swal('Correcto!', 'Registro creado exitosamente!', 'success');
          this.getData();
        } catch {
          swal('Error!', 'Inténtelo de nuevo!', 'error');
        }
      }
    },

    async guardarEditMedioPers() {
      if (this.validarForm() === 1) {
        try {
          await api.post('/medioperss', this.datoMedioPers);
          $('#ventanaModal').modal('hide');
          swal('Correcto!', 'Registro actualizado exitosamente!', 'success');
          this.getData();
        } catch (error) {
          swal('Error!', 'Inténtelo de nuevo!', 'error');
          if (error.response?.data?.errors) {
            Object.values(error.response.data.errors).forEach(e => swal(String(e)));
          }
        }
      }
    },

    async deleteMedioPers(idMedioPers) {
      try {
        await api.delete('/medioperss/' + idMedioPers);
        this.getData();
      } catch {
        swal('Error!', 'No se pudo eliminar.', 'error');
      }
    },

    //  Modal
    abrirModalCrear() {
      this.datoMedioPers = {};
      this.titulo        = 'Nuevo Medio de Comunicación';
      this.btnCrear      = true;
      this.btnEditar     = false;
    },

    abrirModalEditar(idMedioPers) {
      this.modalWindow = true;
      if (idMedioPers != null) {
        api.get('/vwmedioperss/' + idMedioPers).then(resp => {
          this.datoMedioPers = resp.data;
        });
      }
      $('#ventanaModal').modal('show');
      this.titulo    = 'Editar Medio de Comunicación';
      this.btnCrear  = false;
      this.btnEditar = true;
    },

    //  Catálogos
    fetchMedioComs() {
      api.get('/vwmediocoms')
        .then(r => { this.medioComs = r.data; })
        .catch(e => console.error('Error fetchMedioComs:', e));
    },
  },
};
</script>

<style src="@/assets/css/listaFiltrada.css" scoped></style>